import { mergeDeep } from '../utils/utils';

export class ResponseFields {
  private readonly _defaults: any;
  private readonly _result: any;
  private readonly _fieldNames: string[];

  constructor(defaults: object) {
    this._defaults = JSON.parse(JSON.stringify(defaults));
    this._fieldNames = Object.keys(defaults);
    this._result = {};
  }

  get defaults() {
    return this._defaults;
  }

  toJSON() {
    return this.calculatedFields();
  }

  processResponse(data: any) {
    if (data === undefined || data === null){
      return;
    }
    this._fieldNames.forEach(k => {
      const mapping = this._defaults[k].mapping || `response.${k}`;
      let maps = mapping.split('.');
      const val = maps.reduce((obj, key) => obj?.[key], data);
      if (val !== undefined) {
        this._result[k] = {value: val};
      }
    });
  }

  get fieldNames(): string[] {
    return this._fieldNames;
  }

  asComponentChildren(success: boolean) {
    return Object.entries(this.calculatedFields())
      .filter(([_k, v]) => {
        return (success) ? v.showOnSuccess : v.showOnFailure;
      })
      .filter(([_k, v]) => {
        return (!(v.ignoreIfEmpty && (v.value === null || v.value === undefined || v.value === '')));
      })
      .sort(([_ak, av], [_bk, bv]) => {
        const orderA = av.order === undefined ? 1000 : av.order;
        const orderB = bv.order === undefined ? 1000 : bv.order;
        return orderA - orderB;
      })
      .map(([k, v]) => {
        return {
          name: k,
          label: v.label,
          value: v.value,
          action: v.action,
          component: v.component || 'field',
        }
      })
  }

  calculatedFields(): Record<string, any> {
    return mergeDeep(this._defaults, this._result)
  }
}
